

























import { QVueGlobals } from 'quasar';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ListingFilter from '@/components/ListingFilter.vue';
import ListingTable from '@/components/ListingTable.vue';

@Component({
    components: {
        ListingFilter,
        ListingTable,
    },
})
export default class Drawer extends Vue {

    public widthThresholdValue: number = 1200;
    public heightThresholdValue: number = 415;

    get shouldShowDrawer(): boolean {
        if (this.isLandscape) {
            if ((this.$q.screen.width >= this.widthThresholdValue)) {
                return true;
            }
        }
        return false;
    }

    get isLandscape(): boolean {
        return this.$q.screen.width > this.$q.screen.height;
    }

    get map(): L.Map {
        return this.$store.state.map;
    }

    get leftDrawerOpen(): boolean {
        return this.$store.state.leftDrawerOpen;
    }

    public toggleDrawer() {
        this.$store.dispatch('setLeftDrawerOpen', !this.leftDrawerOpen);
    }

    public refreshMap() {
        // there is not an after-hide event so we need to wait for the transition effect
        if (this.map) {
            setTimeout(() => {
                this.map.invalidateSize();
            }, 50);
        }
    }
}

